import { render, staticRenderFns } from "./reel-filters.vue?vue&type=template&id=27d7c10c&scoped=true&"
import script from "./reel-filters.vue?vue&type=script&lang=js&"
export * from "./reel-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7c10c",
  null
  
)

export default component.exports